import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const UnfollowConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  entityName,
  isPending = false,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 700, pb: 0.5 }}>
      Unfollow {entityName || "this"}?
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary">
        You'll stop seeing updates from {entityName || "them"} in your feed.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} disabled={isPending}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={isPending}
        sx={{ bgcolor: "#d32f2f", "&:hover": { bgcolor: "#b71c1c" } }}
      >
        {isPending ? (
          <CircularProgress size={20} sx={{ color: "white" }} />
        ) : (
          "Unfollow"
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnfollowConfirmDialog;
